export enum SelectedTripTypes {
  SET_TAX_AND_TRANSPORTATION_AND_SUPPLEMENT = 'SET_TAX_AND_TRANSPORTATION_AND_SUPPLEMENT',
  SET_TRANSPORTATION = 'SET_TRANSPORTATION',
}
